export default __webpack_public_path__ + "static/media/Cloak of Ibis.38f48c0e.jpg";